import request from '@/utils/request'


// 查询设备地暖设置列表
export function listHeatingSetting(query) {
  return request({
    url: '/mibo/device-heating-setting/list',
    method: 'get',
    params: query
  })
}

// 查询设备地暖设置分页
export function pageHeatingSetting(query) {
  return request({
    url: '/mibo/device-heating-setting/page',
    method: 'get',
    params: query
  })
}

// 查询设备地暖设置详细
export function getHeatingSetting(data) {
  return request({
    url: '/mibo/device-heating-setting/detail',
    method: 'get',
    params: data
  })
}

// 新增设备地暖设置
export function addHeatingSetting(data) {
  return request({
    url: '/mibo/device-heating-setting/add',
    method: 'post',
    data: data
  })
}

// 修改设备地暖设置
export function updateHeatingSetting(data) {
  return request({
    url: '/mibo/device-heating-setting/edit',
    method: 'post',
    data: data
  })
}

// 删除设备地暖设置
export function delHeatingSetting(data) {
  return request({
    url: '/mibo/device-heating-setting/delete',
    method: 'post',
    data: data
  })
}
